import { render } from "./RteStreamInstance.vue?vue&type=template&id=4a1c3284&scoped=true"
import script from "./RteStreamInstance.vue?vue&type=script&lang=js"
export * from "./RteStreamInstance.vue?vue&type=script&lang=js"

import "./RteStreamInstance.vue?vue&type=style&index=0&id=4a1c3284&lang=scss"
import "./RteStreamInstance.vue?vue&type=style&index=1&id=4a1c3284&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a1c3284"

export default script